<template>
  <open-banking-description-step class="obk-description-no-ad-blocker-step" :step-number="stepNumber">
    <template v-slot:text>
      <div>אם יש לך חוסם פרסומות פעיל - צריך לנטרל אותו לפני חיבור החשבון (ולאחר מכן אפשר להחזיר)</div>
    </template>
  </open-banking-description-step>
</template>

<script>
import OpenBankingDescriptionStep from '@/base-components/onboarding/openBanking/OpenBankingDescriptionStep';

export default {
  name: 'ObkDescriptionNoAdBlockerStep',
  components: {
    OpenBankingDescriptionStep,
  },
  props: {
    stepNumber: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
